import { useEffect, useState } from "react";
import { API } from "../api";

const isMobile = window.innerWidth < 640;

export default function SuccessScreen({
  report,
  company,
  questions,
  answers,
  otherInputs,
  onContinue
}) {

  const [displayScore, setDisplayScore] = useState(0);
  const [showConfetti, setShowConfetti] = useState(true);
  const [emailSent, setEmailSent] = useState(false);

  useEffect(() => {
    const target = report?.score || 0;
    let current = 0;

    const interval = setInterval(() => {
      current += Math.ceil(target / 20);

      if (current >= target) {
        current = target;
        clearInterval(interval);
      }

      setDisplayScore(current);
    }, 30);

    // stop confetti after 2.5 sec
    setTimeout(() => setShowConfetti(false), 2500);

    return () => clearInterval(interval);
  }, [report]);

  const formatCurrency = (value) => {
    if (!value || isNaN(value)) return "0";
    return value.toLocaleString();
  };

  const scheduleMeeting = () => {
    const safeCompany = company || {};
    const safeReport = report || {};

    const userEmail = safeCompany.email || "";
    const hostEmail = "contactus@emeistechnologies.com";

    // ✅ BOTH emails added
    const guests = encodeURIComponent(
      [userEmail, hostEmail].filter(Boolean).join(",")
    );

    const title = encodeURIComponent(
      "AI Strategy Consultation - Emeis Technologies"
    );

    const details = encodeURIComponent(
      `Discussion on AI Growth Report

      Company: ${safeCompany.companyName || "N/A"}
      AI Score: ${safeReport.score || "0"}
      ROI: ₹${safeReport.roi ? safeReport.roi.toLocaleString() : "0"}

      Host: contactus@emeistechnologies.com`
    );

    const calendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&details=${details}&add=${guests}&location=Google+Meet`;

    window.open(calendarUrl, "_blank");
  };

  const sendEmail = async () => {
    try {

      const formattedAnswers = questions.map(q => ({
        question_id: q.id,
        question: q.question,
        answer:
          answers[q.id] === "other"
            ? otherInputs[q.id]
            : answers[q.id]
      }));

      console.log("formattedAnswers-------_###########", formattedAnswers);

      const res = await API.post("/send-lead-email", {
        company,
        report,
        answers: formattedAnswers,
        aiResponse: report?.fullReport || report?.analysis || ""
      });

      console.log("API RESPONSE:", res.data);

    } catch (err) {
      console.error("Email failed:", err);
    }
  };

  const handleViewReport = async () => {
    if (!emailSent) {
      await sendEmail();
      setEmailSent(true);
    }
    onContinue();
  };

  return (
    <div style={styles.wrapper}>
      {showConfetti && (
        <div style={styles.confetti}>
          {[...Array(30)].map((_, i) => (
            <div key={i} style={{
              ...styles.confettiPiece,
              left: Math.random() * 100 + "%",
              animationDelay: Math.random() + "s"
            }} />
          ))}
        </div>
      )}
      <div style={styles.card}>

        <h1 style={styles.title}>🎉 Your AI Report is Ready</h1>

        {/* SCORE */}
        <div style={styles.scoreBox}>
          <div style={styles.scoreCircle}>
            {displayScore}
          </div>
          <p style={styles.scoreLabel}>AI Maturity Score</p>
        </div>

        {/* ROI */}
        <div style={styles.roi}>
          Estimated ROI: <span>₹{formatCurrency(report?.roi)}</span>
        </div>

        <p style={styles.desc}>
          AI can significantly improve efficiency and unlock exponential growth.
        </p>

        {/* CTA */}
        <div style={styles.actions}>
          <button style={styles.primaryBtn} onClick={handleViewReport}>
            View Full Report
          </button>

          <button style={styles.secondaryBtn} onClick={scheduleMeeting}>
            📅 <span>Book AI Strategy Call</span>
          </button>
        </div>

      </div>
    </div>
  );
}

const styles = {

  wrapper: {
    minHeight: "100vh",
    background: "linear-gradient(135deg,#eef2ff,#f8fafc)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: isMobile ? 16 : 20
  },

  card: {
    background: "linear-gradient(#fff,#fff) padding-box, linear-gradient(135deg,#6366f1,#8b5cf6) border-box",
    border: "2px solid transparent",
    padding: isMobile ? 20 : 40,
    borderRadius: 24,
    textAlign: "center",
    width: "100%",
    maxWidth: 500,
    boxShadow: "0 20px 60px rgba(99,102,241,0.15)"
  },
  title: {
    fontSize: isMobile ? 22 : 30,
    fontWeight: 700,
    marginBottom: 16,
    lineHeight: 1.3
  },

  scoreBox: {
    margin: "20px 0"
  },

  scoreCircle: {
    width: isMobile ? 90 : 120,
    height: isMobile ? 90 : 120,
    borderRadius: "50%",
    background: "linear-gradient(135deg,#6366f1,#8b5cf6)",
    color: "#fff",
    fontSize: isMobile ? 28 : 40,
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    boxShadow: "0 10px 30px rgba(99,102,241,0.5)"
  },
  scoreLabel: {
    marginTop: 10,
    color: "#64748b"
  },

  roi: {
    fontSize: isMobile ? 16 : 20,
    marginTop: 10
  },

  desc: {
    marginTop: 16,
    color: "#475569",
    fontSize: isMobile ? 13 : 15
  },

  actions: {
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    gap: 10,
    justifyContent: "center",
    marginTop: 24
  },

  primaryBtn: {
    padding: "14px",
    width: isMobile ? "100%" : "auto",
    borderRadius: 12,
    border: "none",
    background: "linear-gradient(90deg,#6366f1,#8b5cf6)",
    color: "#fff",
    fontWeight: 600
  },

  secondaryBtn: {
    padding: "14px",
    width: isMobile ? "100%" : "auto",
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    background: "#fff",
    fontWeight: 600,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    transition: "all 0.2s",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
  },

  confetti: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    overflow: "hidden"
  },

  confettiPiece: {
    position: "absolute",
    width: 8,
    height: 12,
    background: "linear-gradient(45deg,#6366f1,#8b5cf6)",
    top: -20,
    animation: "fall 2.5s linear forwards"
  },

};